import { jsx as _jsx } from "react/jsx-runtime";
import { useFocusRing } from '@react-aria/focus';
import { useListBox } from '@react-aria/listbox';
import { mergeProps } from '@react-aria/utils';
import { useRef } from 'react';
import classNames from 'classnames';
import { DropdownOption } from './DropdownOption';
import { getKeyItemRecord, isArrayOfOptionGroup } from './helper';
import styles from './Dropdown.module.scss';
import { DropdownOptionGroup } from './DropdownOptionGroup';
const DropdownSelectMenu = ({ ariaProps, state, showCheckIcon, options, ariaLabel, ariaLabelledBy, }) => {
    const ref = useRef(null);
    const keyItemRecord = getKeyItemRecord(options);
    const { focusProps } = useFocusRing();
    const { listBoxProps } = useListBox({
        ...ariaProps,
        'aria-label': ariaLabel,
        'aria-labelledby': ariaLabel ? undefined : ariaLabelledBy,
    }, state, ref);
    function renderOptionList(listOptions, optionProps = {}) {
        return listOptions.map((option, index) => {
            return (_jsx(DropdownOption, { showCheckIcon: showCheckIcon, state: state, node: option, item: keyItemRecord[option.key], index: index, ...optionProps }, option.key));
        });
    }
    function renderAsOptionGroups() {
        return Array.from(state.collection, section => {
            return (_jsx(DropdownOptionGroup, { title: section.key, ariaLabel: section['aria-label'], children: renderOptionList(Array.from(section.childNodes), { className: 'pl-4x' }) }, section.key));
        });
    }
    function renderAsNonOptionGroups() {
        return renderOptionList(Array.from(state.collection));
    }
    return (_jsx("ul", { className: classNames('p-0', styles.dropdownSelectMenu), ...mergeProps(listBoxProps, focusProps), ref: ref, children: isArrayOfOptionGroup(options) ? renderAsOptionGroups() : renderAsNonOptionGroups() }));
};
export { DropdownSelectMenu };
